import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/lib/api/useApiClient';
import { useAuth } from '@/lib/auth/useAuth';
import type { AuditLogFilters, AuditLogResponse } from './types';

const auditKeys = {
  all: ['admin-audit-log'] as const,
  list: (filters: AuditLogFilters) => [...auditKeys.all, filters] as const,
};

function buildQuery(filters: AuditLogFilters): Record<string, string | number | undefined> {
  return {
    customerId: filters.customerId,
    action: filters.action,
    dateFrom: filters.dateFrom,
    dateTo: filters.dateTo,
    limit: filters.limit,
    offset: filters.offset,
  };
}

export function useAuditLog(filters: AuditLogFilters) {
  const api = useApiClient();
  const { accessToken, hasRole } = useAuth();
  return useQuery({
    queryKey: auditKeys.list(filters),
    // Only admins can hit this endpoint — the gate is also enforced server-
    // side, but skipping the request for non-admins avoids a useless 403.
    enabled: Boolean(accessToken) && hasRole('admin'),
    queryFn: () =>
      api.request<AuditLogResponse>('/admin/audit-log', {
        query: buildQuery(filters),
      }),
  });
}
